const STORAGE_KEY = "evidence-review-selection";

export const saveEvidenceSelection = (selection) => {
  if (!selection) {
    return;
  }

  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(selection));
};

export const getEvidenceSelection = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }

    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
};

export const clearEvidenceSelection = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};
